import arrayBufferToHex from 'array-buffer-to-hex';
import digestSync from 'crypto-digest-sync';
export const hashString = (string) => {
    const buf = new TextEncoder().encode(string);
    return arrayBufferToHex(digestSync('SHA-256', buf));
};
